import { render, staticRenderFns } from "./DatosFaltantesBanner.vue?vue&type=template&id=f37bd7b0"
import script from "./DatosFaltantesBanner.vue?vue&type=script&lang=js"
export * from "./DatosFaltantesBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports